<template>
	<div class="d-flex min-vh-100 align-items-center justify-content-center logout">
		<p>Logging out...</p>

		<BaseAppVersion />
	</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseAppVersion from '@/components/BaseAppVersion.vue';
import { ROUTE_NAME } from '../enums/route';

export default {
	name: 'LogoutPage',
	components: {
		BaseAppVersion,
	},
	computed: {
		...mapState('auth', ['isLoggedIn']),
	},
	async created() {
		try {
			if (this.isLoggedIn) {
				await this.logout();
			}
		} catch (e) {
			// eslint-disable-next-line
			console.error('Logout error:', e);
		} finally {
			this.$router.replace({ name: ROUTE_NAME.LOGIN });
		}
	},
	methods: {
		...mapActions('auth', ['logout']),
	},
};
</script>

<style scoped>
.logout {
	color: #777;
}
</style>
